module.exports = __webpack_public_path__ + "img/InformV2.57a41565.png";